module.exports = __webpack_public_path__ + "static/img/normal.68bee5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/normal.png
// module id = wAM6
// module chunks = 2